// HACKATHON: Crypto Cards with Categories
import React from 'react';
import { useCryptoAll } from './useCrypto';

// Categorization function (your original logic)
const categorizeCrypto = (cryptoData) => {
  if (!cryptoData || !Array.isArray(cryptoData)) return null;

  const currency = [];
  const stablecoin = [];
  const memecoin = [];
  const chain = [];
  const cefi = [];
  const other = [];

  cryptoData.forEach(coin => {
    const { name, symbol } = coin;
    const lowerName = name.toLowerCase();
    const lowerSymbol = symbol.toLowerCase();

    if (lowerName.includes('stable') || lowerName.includes('usd') || 
        lowerSymbol === 'usdt' || lowerSymbol === 'usdc' || lowerSymbol === 'dai' || 
        lowerSymbol === 'usde' || lowerSymbol === 'pyusd' || lowerSymbol === 'fdusd') {
      stablecoin.push(coin);
    } else if (lowerName.includes('meme') || lowerName.includes('doge') || 
               lowerName.includes('shiba') || lowerName.includes('pepe') || 
               lowerName.includes('bonk') || lowerName.includes('floki') || 
               lowerName.includes('trump')) {
      memecoin.push(coin);
    } else if (lowerName.includes('chain') || lowerName.includes('network') || 
               lowerName.includes('protocol')) {
      chain.push(coin);
    } else if (lowerName.includes('tron') || lowerName.includes('binance') || 
               lowerName.includes('bitget') || lowerName.includes('kucoin') || 
               lowerName.includes('okb') || lowerName.includes('gate')) {
      cefi.push(coin);
    } else if (lowerName.includes('bitcoin') || lowerName.includes('ethereum') || 
               lowerName.includes('litecoin') || lowerSymbol === 'btc' || 
               lowerSymbol === 'eth' || lowerSymbol === 'ltc') {
      currency.push(coin);
    } else {
      other.push(coin);
    }
  });

  return { currency, stablecoin, memecoin, chain, cefi, other };
};

// Main Crypto Section Component
export const CryptoCardsSection = ({ theme }) => {
  const { data: cryptoData, loading } = useCryptoAll();

  if (loading) {
    return (
      <div style={{
        background: theme.cardBg,
        borderRadius: '12px',
        padding: '2rem',
        border: `1px solid ${theme.border}`,
        backdropFilter: 'blur(10px)'
      }}>
        <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#D4AF37' }}>
          ₿ Criptomoedas
        </h3>
        <p style={{ color: theme.textSecondary, marginTop: '1rem' }}>
          Carregando dados...
        </p>
      </div>
    );
  }

  if (!cryptoData || cryptoData.length === 0) {
    return (
      <div style={{
        background: theme.cardBg,
        borderRadius: '12px',
        padding: '2rem',
        border: `1px solid ${theme.border}`,
        backdropFilter: 'blur(10px)'
      }}>
        <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#D4AF37' }}>
          ₿ Criptomoedas
        </h3>
        <p style={{ color: theme.textSecondary, marginTop: '1rem' }}>
          Nenhum dado disponível
        </p>
      </div>
    );
  }

  const categorized = categorizeCrypto(cryptoData);

  return (
    <div>
      <h3 style={{ 
        fontSize: '1.5rem', 
        fontWeight: 'bold', 
        color: '#D4AF37',
        marginBottom: '1.5rem'
      }}>
        ₿ Criptomoedas por Categoria
      </h3>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
        gap: '1.5rem'
      }}>
        <CryptoCard 
          title="💰 Currency" 
          icon="₿"
          data={categorized.currency.slice(0, 5)} 
          theme={theme} 
        />
        <CryptoCard 
          title="🏦 Stablecoin" 
          icon="💵"
          data={categorized.stablecoin.slice(0, 5)} 
          theme={theme} 
        />
        <CryptoCard 
          title="🐕 Memecoin" 
          icon="🚀"
          data={categorized.memecoin.slice(0, 5)} 
          theme={theme} 
        />
        <CryptoCard 
          title="⛓️ Chain" 
          icon="🔗"
          data={categorized.chain.slice(0, 5)} 
          theme={theme} 
        />
        <CryptoCard 
          title="🏢 CeFi" 
          icon="🏦"
          data={categorized.cefi.slice(0, 5)} 
          theme={theme} 
        />
        <CryptoCard 
          title="💎 Other" 
          icon="✨"
          data={categorized.other.slice(0, 5)} 
          theme={theme} 
        />
      </div>
    </div>
  );
};

// Individual Category Card
const CryptoCard = ({ title, icon, data, theme }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  if (!data || data.length === 0) return null;

  return (
    <div 
      style={{
        background: theme.cardBg,
        borderRadius: '12px',
        padding: '1.5rem',
        border: `1px solid ${isHovered ? theme.borderHover : theme.border}`,
        backdropFilter: 'blur(10px)',
        transition: 'all 0.3s',
        boxShadow: isHovered ? '0 10px 30px rgba(139, 0, 0, 0.15)' : 'none'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Header */}
      <h4 style={{ 
        fontSize: '1.1rem', 
        fontWeight: 'bold', 
        color: '#D4AF37',
        marginBottom: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
      }}>
        <span>{icon}</span>
        {title}
      </h4>

      {/* Coin List */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {data.map((coin, i) => (
          <div 
            key={i} 
            style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              padding: '0.75rem',
              background: 'rgba(0,0,0,0.2)',
              borderRadius: '8px',
              transition: 'all 0.2s'
            }}
          >
            {/* Left: Symbol & Name */}
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, color: theme.textPrimary, fontSize: '0.9rem' }}>
                {coin.symbol}
              </div>
              <div style={{ fontSize: '0.7rem', color: theme.textSecondary }}>
                {coin.name}
              </div>
            </div>

            {/* Right: Price & Change */}
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontFamily: 'monospace', fontSize: '0.85rem', color: theme.textPrimary }}>
                ${coin.price >= 1 ? coin.price.toFixed(2) : coin.price.toFixed(6)}
              </div>
              <div style={{ 
                fontSize: '0.7rem', 
                fontWeight: 600, 
                color: coin.percent_change_24h >= 0 ? '#4ade80' : '#ef4444' 
              }}>
                {coin.percent_change_24h >= 0 ? '+' : ''}
                {coin.percent_change_24h?.toFixed(2)}%
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Compact version - Top cryptos only
export const CryptoTopCard = ({ theme, maxItems = 10 }) => {
  const { data: cryptoData, loading } = useCryptoAll();

  if (loading || !cryptoData) return null;

  const topCoins = cryptoData.slice(0, maxItems);

  return (
    <div style={{
      background: theme.cardBg,
      borderRadius: '12px',
      padding: '1.5rem',
      border: `1px solid ${theme.border}`,
      backdropFilter: 'blur(10px)'
    }}>
      <h3 style={{ 
        fontSize: '1.1rem', 
        fontWeight: 'bold', 
        color: '#D4AF37',
        marginBottom: '1.5rem'
      }}>
        ₿ Top Criptos
      </h3>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {topCoins.map((coin, i) => (
          <div 
            key={i}
            style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              padding: '0.75rem',
              background: 'rgba(0,0,0,0.2)',
              borderRadius: '8px'
            }}
          >
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: 600, color: theme.textPrimary, fontSize: '0.9rem' }}>
                {coin.symbol}
              </span>
              <span style={{ fontSize: '0.7rem', color: theme.textSecondary, marginLeft: '0.5rem' }}>
                #{i + 1}
              </span>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontFamily: 'monospace', fontSize: '0.85rem', color: theme.textPrimary }}>
                ${coin.price >= 1 ? coin.price.toFixed(2) : coin.price.toFixed(6)}
              </div>
              <div style={{ 
                fontSize: '0.7rem', 
                fontWeight: 600, 
                color: coin.percent_change_24h >= 0 ? '#4ade80' : '#ef4444' 
              }}>
                {coin.percent_change_24h >= 0 ? '+' : ''}
                {coin.percent_change_24h?.toFixed(2)}%
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
